import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";
import { retryWrapper } from "retry-wrapper";

const state = {
  customerUpdated: null,
};

const mutations = {
  setCustomerUpdated(state, customer) {
    state.customerUpdated = customer;
  },
};

const actions = {
  async getCustomerByWorkgroupAndPhone(_, params) {
    try {
      const response = await ApiClient().get("customers/customers2", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error(
        "ERROR while getting customer on getCustomerByWorkgroupAndPhone action: ",
        error.message
      );
    }
  },

  async createCustomer(_, params) {
    try {
      await ApiClient().post("customers", params, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR while creating a customer on createCustomer: ", error.message);
      return false;
    }
  },

  async updateCustomerById(_, payload) {
    const { phoneId, wgId, data } = payload;
    const params = {
      wgId,
      phoneId,
    };

    try {
      await ApiClient().patch("customers", data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return true;
    } catch (error) {
      console.error("ERROR while updating a customer on updateCustomer: ", error.message);
    }
    return false;
  },

  async getCustomerByPhone({ rootGetters }, params) {
    const requestParams = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...params,
    };
    try {
      const api = ApiClient();
      const retryableGet = retryWrapper(5, api.get);
      let response = await retryableGet("customers/customers2", {
        params: requestParams,
      });
      return response.data;
    } catch (error) {
      console.info("A customer call failed after 5 attempts", { error, params: requestParams });
      console.error("ERROR en getCustomerByPhone: ", error.message);
    }
  },

  async updateCustomer({ rootGetters }, payload) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };
    const urlFormData = qs.stringify(payload.data);

    try {
      const api = ApiClient();
      let response = await api.put("customers", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en updateCustomer: ", error.message);
      return error.message;
    }
  },

  async updateCustomerPatch({ rootGetters }, payload) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };

    try {
      const api = ApiClient();
      let response = await api.patch("customers", payload.data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en updateCustomerPatch: ", error.message);
      return error.message;
    }
  },
};

const getters = {
  customers(state) {
    return state.customers;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
